/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Grid, Typography } from '@mui/material';
import { BoxIcon } from './style';
/**
 * Event index with color codes is defined here
 * @returns
 */
const EventIndex = () => (
  <Grid container direction="row" p={3}>
    <Grid item container direction="row" xs={3}>
      <BoxIcon sx={{ backgroundColor: '#6FBB10' }} alignSelf="center" mr={1} />
      <Typography variant="caption" alignSelf="center">
        Regular sports event
      </Typography>
    </Grid>
    <Grid item container direction="row" xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#B9273C' }} alignSelf="center" mr={1} />
      <Typography variant="caption" alignSelf="center">
        Special / Annual sports event
      </Typography>
    </Grid>
    <Grid item container direction="row" xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#F9EC2B' }} alignSelf="center" mr={1} />
      <Typography variant="caption" alignSelf="center">
        Weather (forecastable)
      </Typography>
    </Grid>
    <Grid item container direction="row" xs={3} wrap="nowrap">
      <BoxIcon className="icon" sx={{ backgroundColor: '#B43292' }} alignSelf="center" mr={1} />
      <Typography variant="caption" alignSelf="center">
        Weather/Natural disaster(non–forecastable)
      </Typography>
    </Grid>
    <Grid item container direction="row" xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#FCC71F' }} alignSelf="center" mr={1} />
      <Typography variant="caption">Holiday</Typography>
    </Grid>
    <Grid item container direction="row" xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#8E61A6' }} alignSelf="center" mr={1} />
      <Typography variant="caption">Long Weekend</Typography>
    </Grid>
    <Grid container direction="row" item xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#FFA657' }} alignSelf="center" mr={1} />
      <Typography variant="caption">Festivals</Typography>
    </Grid>
    <Grid container direction="row" item xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#323B96' }} alignSelf="center" mr={1} />
      <Typography variant="caption">Entertainment</Typography>
    </Grid>
    <Grid container direction="row" item xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#F0642F' }} alignSelf="center" mr={1} />
      <Typography variant="caption">City wide conferences (w/rooms)</Typography>
    </Grid>
    <Grid container direction="row" item xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#01AFC8' }} alignSelf="center" mr={1} />
      <Typography variant="caption">Conferences&shows (no rooms)</Typography>
    </Grid>
    <Grid container direction="row" item xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#EB2A2D' }} alignSelf="center" mr={1} />
      <Typography variant="caption">Hotel group bookings</Typography>
    </Grid>
    <Grid container direction="row" item xs={3}>
      <BoxIcon className="icon" sx={{ backgroundColor: '#6AB98C' }} alignSelf="center" mr={1} />
      <Typography variant="caption">Others</Typography>
    </Grid>
  </Grid>
);
//
export default EventIndex;
